/* ============================================================
   SMARTCUBES — bløde sideskift og kurv-bevægelse (v4)
   Ved klik på et internt link toner indholdet ud (0,3 s), mens
   headeren står stille. Den nye sides indhold toner roligt frem
   (1,1 s), så snart siden er klar. Links, som andre scripts
   håndterer (kurv-skuffe, menuer m.m.), røres ikke.
   ============================================================ */
(function () {
  'use strict';

  var doc = document, html = doc.documentElement;
  if (window.Shopify && window.Shopify.designMode) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  /* Navigationen starter, når indholdet er tonet ud */
  var timer = null, NAV_AFTER = 250, FADE_IN = 1100;

  /* ---- Ny side: indholdet starter usynligt og toner frem ---- */
  function reveal() {
    if (!html.classList.contains('sc-cover') || html.classList.contains('sc-in')) return;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        html.classList.add('sc-in');
        setTimeout(function () {
          if (!html.classList.contains('sc-leaving')) html.classList.remove('sc-cover', 'sc-in');
        }, FADE_IN + 80);
      });
    });
  }
  function whenReady() {
    if (!html.classList.contains('sc-cover')) return;
    /* Skrifterne ligger i cachen ved sideskift — vent højst 0,2 s på dem,
       så teksten ikke skifter skrift, mens den toner frem */
    var done = false;
    function go() { if (!done) { done = true; reveal(); } }
    setTimeout(go, 200);
    try {
      if (doc.fonts && doc.fonts.ready) doc.fonts.ready.then(go, go);
      else go();
    } catch (e) { go(); }
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', whenReady);
  else whenReady();

  function clear() {
    html.classList.remove('sc-leaving');
    if (timer) { clearTimeout(timer); timer = null; }
  }
  function showAgain() {
    clear();
    html.classList.remove('sc-in');
    html.classList.add('sc-cover');
    reveal();
  }

  /* Tilbage-knappen (bfcache): indholdet toner frem igen */
  window.addEventListener('pageshow', function (e) {
    if (html.classList.contains('sc-leaving')) showAgain();
  });
  doc.addEventListener('visibilitychange', function () {
    if (doc.visibilityState === 'visible' && html.classList.contains('sc-leaving')) showAgain();
  });

  function isInternalPageLink(a, e) {
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return false;
    if (a.target && a.target !== '_self') return false;
    if (a.hasAttribute('download') || a.hasAttribute('data-no-transition')) return false;
    var href = a.getAttribute('href');
    if (!href || href.charAt(0) === '#' || /^(mailto|tel|sms|javascript):/i.test(href)) return false;
    var url;
    try { url = new URL(a.href, location.href); } catch (x) { return false; }
    if (url.origin !== location.origin) return false;
    if (url.pathname === location.pathname && url.search === location.search) return false;
    return true;
  }

  /* ---- Kunden trykker på et link: indholdet toner ud med det samme ----
     Lytter på window, så alle andre klik-handlere (kurv-skuffe, menuer)
     har kørt først. Har de stoppet linket, gør vi intet. */
  window.addEventListener('click', function (e) {
    if (e.defaultPrevented) return;
    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (!a || !isInternalPageLink(a, e)) return;
    var url = a.href;
    e.preventDefault();
    /* Mobilmenuen lukkes, så man ser indholdet tone ud */
    var menu = a.closest('details[open]');
    if (menu && menu.closest('header, .header-wrapper, menu-drawer, header-drawer')) {
      var summary = menu.querySelector('summary');
      if (summary) summary.click(); else menu.removeAttribute('open');
    }
    html.classList.remove('sc-cover', 'sc-in');
    html.classList.add('sc-leaving');
    try { sessionStorage.setItem('sc-nav', String(Date.now())); } catch (x) {}
    setTimeout(function () { window.location.href = url; }, NAV_AFTER);
    timer = setTimeout(showAgain, 5000);
  });
})();

/* ============================================================
   Hurtigere sideskift: når kunden holder fingeren/musen på et link,
   hentes næste side i forvejen, så den er klar ved klikket.
   (Chrome/Edge/Android. Kurv, checkout og konto hentes aldrig.)
   ============================================================ */
(function () {
  'use strict';
  try {
    if (window.Shopify && window.Shopify.designMode) return;
    var c = navigator.connection;
    if (c && (c.saveData || /2g/.test(c.effectiveType || ''))) return;
    if (!(window.HTMLScriptElement && HTMLScriptElement.supports && HTMLScriptElement.supports('speculationrules'))) return;
    var rules = {
      prefetch: [{
        where: { and: [
          { href_matches: '/*' },
          { not: { href_matches: ['/cart', '/cart/*', '/checkout*', '/checkouts/*', '/account*', '/apps/*', '/*/cart*'] } },
          { not: { selector_matches: '[data-no-transition], [download], [target=_blank], [rel~=nofollow]' } }
        ] },
        eagerness: 'moderate'
      }]
    };
    var el = document.createElement('script');
    el.type = 'speculationrules';
    el.textContent = JSON.stringify(rules);
    document.head.appendChild(el);
  } catch (e) {}
})();

/* ============================================================
   Kurv (alle sider)
   - Kurv-tallet i headeren hopper, når en vare lægges i kurven
   - Kurv-skuffen: varerne glider ind, den nye vare fremhæves kort
   - Fri fragt-baren: en lille lastbil kører med, flueben ved målet
   ============================================================ */
(function () {
  'use strict';

  var doc = document, html = doc.documentElement;
  var TRUCK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.35" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<path d="M2.5 6.5h11v9h-11z"/><path d="M13.5 9.5h4l3 3.2v2.8h-7"/>' +
    '<path d="M5.4 17.6a1.6 1.6 0 1 0 3.2 0a1.6 1.6 0 1 0 -3.2 0"/><path d="M15.4 17.6a1.6 1.6 0 1 0 3.2 0a1.6 1.6 0 1 0 -3.2 0"/></svg>';

  var newVariant = null, newUntil = 0, queued = false, lastPct = 0, openedAt = 0;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var drawer = doc.querySelector('cart-drawer');

  function each(list, fn) { Array.prototype.forEach.call(list, fn); }

  function markNew() {
    if (!newVariant || Date.now() > newUntil) return;
    var links = doc.querySelectorAll('cart-drawer .cart-item a[href*="variant="], cart-drawer .scdr-item a[href*="variant="]');
    /* Skuffen tegnes ofte om lige efter købet — den nye række markeres igen */
    for (var i = 0; i < links.length; i++) {
      var m = links[i].getAttribute('href').match(/variant=(\d+)/);
      if (m && m[1] === newVariant) {
        var row = links[i].closest('.cart-item, .scdr-item');
        if (row && !row.classList.contains('scx-new')) row.classList.add('scx-new');
      }
    }
  }

  function scan() {
    queued = false;
    each(doc.querySelectorAll('.sc-ship'), function (s) {
      var fill = s.querySelector('.sc-ship__fill');
      if (fill && !fill.querySelector('.scx-truck')) {
        fill.insertAdjacentHTML('beforeend', '<span class="scx-truck" aria-hidden="true">' + TRUCK + '</span>');
      }
      if (!s.classList.contains('scx-ship')) s.classList.add('scx-ship');
    });
    /* Kurv-skuffen: lastbilen kører fra forrige til ny værdi */
    each(doc.querySelectorAll('.scdr-ship__fill'), function (f) {
      if (f.querySelector('.scx-truck')) return;
      f.insertAdjacentHTML('beforeend', '<span class="scx-truck" aria-hidden="true">' + TRUCK + '</span>');
      f.setAttribute('data-scx-w', parseFloat(f.style.width) || 0);
      if (drawer && drawer.classList.contains('active')) animateFill(f, Date.now() - openedAt < 900 ? 0 : lastPct);
      else lastPct = parseFloat(f.getAttribute('data-scx-w')) || 0;
    });
    if (doc.querySelector('cart-drawer .scdr-ship.is-done')) lastPct = 100;
    else if (drawer && !drawer.querySelector('.scdr-ship')) lastPct = 0;
    markNew();
  }

  function animateFill(f, from) {
    var target = parseFloat(f.getAttribute('data-scx-w')) || 0;
    lastPct = target;
    if (reduce || from === target) return;
    f.style.transition = 'none';
    f.style.width = from + '%';
    void f.offsetWidth;
    f.style.transition = '';
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { f.style.width = target + '%'; });
    });
  }
  function queue() { if (!queued) { queued = true; setTimeout(scan, 30); } }

  if ('MutationObserver' in window && doc.body) {
    /* Kun kurv-skuffen og kurvsiden følges — andre ændringer på siden ignoreres */
    var cartPage = /\/cart\/?$/.test(location.pathname);
    var mo = new MutationObserver(queue);
    if (drawer) mo.observe(drawer, { childList: true, subtree: true });
    if (cartPage) mo.observe(doc.body, { childList: true, subtree: true });
  }
  queue();

  /* Kurv-skuffen åbner: varerne glider ind, lastbilen kører fra start */
  if (drawer && 'MutationObserver' in window) {
    var open = drawer.classList.contains('active'), t = null;
    new MutationObserver(function () {
      var now = drawer.classList.contains('active');
      if (now && !open) {
        drawer.classList.add('scx-open');
        openedAt = Date.now();
        each(drawer.querySelectorAll('.scdr-ship__fill[data-scx-w]'), function (f) { animateFill(f, 0); });
        clearTimeout(t);
        t = setTimeout(function () { drawer.classList.remove('scx-open'); }, 1400);
      }
      open = now;
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  /* Kurven glider først ind, når fluebenet på knappen har nået at blive tegnet.
     Svarer Shopify langsommere end det, åbner den med det samme. */
  var addAt = 0, MIN_OPEN = 650, addedBtns = [];

  /* Fluebenet på knappen vises i samme øjeblik, man trykker — ikke først,
     når Shopify har svaret (det tager typisk 0,4–1 sekund). */
  function setBtn(b, on) { if (b) b.classList[on ? 'add' : 'remove']('is-added'); }
  function releaseBtns(delay) {
    addedBtns.forEach(function (b) {
      clearTimeout(b._scxT);
      b._scxT = setTimeout(function () { setBtn(b, false); }, delay);
    });
  }
  doc.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !/\/cart\/add/.test(f.getAttribute('action') || '')) return;
    var btn = f.querySelector('[type="submit"]');
    if (btn && (btn.disabled || btn.getAttribute('aria-disabled') === 'true')) return;
    var idIn = f.querySelector('[name="id"]');
    if (idIn && idIn.disabled) return;
    addAt = Date.now();
    var root = f.closest('.scp') || f;
    addedBtns = [];
    each(root.querySelectorAll('[data-scp-add], .scd-bar__cta, [data-scp-s-btn]'), function (b) {
      if (!b.querySelector('.scx-ok') && !b.hasAttribute('data-scp-s-btn')) return;
      addedBtns.push(b);
      clearTimeout(b._scxT);
      setBtn(b, true);
    });
    releaseBtns(6000); /* sikkerhedsnet, hvis kurven aldrig svarer */
  }, true);
  if (drawer && !reduce) {
    var realOpen = drawer.open;
    drawer.open = function () {
      var self = this, args = arguments;
      var fn = realOpen || Object.getPrototypeOf(self).open;
      var wait = MIN_OPEN - (Date.now() - addAt);
      if (addAt && wait > 0 && wait <= MIN_OPEN) {
        addAt = 0;
        setTimeout(function () { fn.apply(self, args); }, wait);
      } else {
        addAt = 0;
        fn.apply(self, args);
      }
    };
  }

  /* En vare er lagt i kurven fra en produktside */
  try {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (ev) {
        if (!ev || ev.source !== 'product-form') return;
        newVariant = ev.productVariantId ? String(ev.productVariantId) : null;
        newUntil = Date.now() + 3000;
        releaseBtns(addAt ? Math.max(1400, 1900 - (Date.now() - addAt)) : 1900);
        html.classList.add('scx-added');
        setTimeout(function () { html.classList.remove('scx-added'); }, 1500);
        queue();
      });
      subscribe(PUB_SUB_EVENTS.cartError, function () {
        addAt = 0;
        addedBtns.forEach(function (b) { clearTimeout(b._scxT); setBtn(b, false); });
      });
    }
  } catch (e) {}
})();

/* ============================================================
   Mobilmenuen (de tre streger): mens den er åben, kan siden bag den
   ikke scrolles, så menuen bliver på skærmen. Selve menuen kan stadig
   scrolles, hvis den er længere end skærmen. Headeren bliver fremme.
   ============================================================ */
(function () {
  'use strict';
  var html = document.documentElement;
  function init() {
    var d = document.querySelector('header-drawer details');
    if (!d || !('MutationObserver' in window)) return;
    var locked = false, lockY = 0, startY = 0;

    /* Nærmeste element inde i menuen, der selv kan scrolle */
    function scroller(el) {
      while (el && el !== d) {
        if (el.nodeType === 1 && el.scrollHeight > el.clientHeight + 1) {
          var oy = getComputedStyle(el).overflowY;
          if (oy === 'auto' || oy === 'scroll') return el;
        }
        el = el.parentNode;
      }
      return null;
    }
    /* Må denne bevægelse scrolle? Kun inde i menuen og ikke forbi kanten */
    function allowed(target, dy) {
      var drawer = target && target.closest ? target.closest('.menu-drawer') : null;
      if (!drawer) return false;
      var sc = scroller(target);
      if (!sc) return false;
      if (dy < 0 && sc.scrollTop <= 0) return false; /* trækker nedad i toppen */
      if (dy > 0 && sc.scrollTop + sc.clientHeight >= sc.scrollHeight - 1) return false; /* opad i bunden */
      return true;
    }
    function onStart(e) { if (e.touches && e.touches[0]) startY = e.touches[0].clientY; }
    function onMove(e) {
      if (!e.touches || e.touches.length > 1) return;
      var y = e.touches[0].clientY, dy = startY - y;
      if (!allowed(e.target, dy) && e.cancelable) e.preventDefault();
    }
    function onWheel(e) { if (!allowed(e.target, e.deltaY) && e.cancelable) e.preventDefault(); }
    function onScroll() { if (locked && Math.abs(window.scrollY - lockY) > 1) window.scrollTo(0, lockY); }

    function lock(on) {
      if (on === locked) return;
      locked = on;
      var opt = { passive: false };
      if (on) {
        lockY = window.scrollY;
        document.addEventListener('touchstart', onStart, { passive: true });
        document.addEventListener('touchmove', onMove, opt);
        document.addEventListener('wheel', onWheel, opt);
        window.addEventListener('scroll', onScroll, { passive: true });
      } else {
        document.removeEventListener('touchstart', onStart, { passive: true });
        document.removeEventListener('touchmove', onMove, opt);
        document.removeEventListener('wheel', onWheel, opt);
        window.removeEventListener('scroll', onScroll, { passive: true });
      }
    }
    function sync() {
      var open = d.hasAttribute('open');
      html.classList.toggle('sc-menu-open', open);
      lock(open);
    }
    new MutationObserver(sync).observe(d, { attributes: true, attributeFilter: ['open'] });
    sync();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* ============================================================
   BEVÆGELSE PÅ HELE SIDEN (v1)
   - Elementer under folden toner blødt frem, når de kommer i syne
     (i samme bølge forskudt en anelse, så de kommer ind én efter én)
   - Overskrifter glider op ord for ord
   - Billeder zoomer roligt på plads
   - Knapper får et lysglimt, når de kommer frem
   - FAQ'en på forsiden åbner og lukker blødt
   Elementer, der allerede er i syne ved indlæsning, røres ikke.
   ============================================================ */
(function () {
  'use strict';
  var doc = document, html = doc.documentElement;
  if (window.Shopify && window.Shopify.designMode) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  function each(list, fn) { Array.prototype.forEach.call(list, fn); }
  function q(sel, root) { return (root || doc).querySelectorAll(sel); }
  function belowFold(el) {
    var r = el.getBoundingClientRect();
    return r.height > 0 && r.top > window.innerHeight * 0.9;
  }

  /* Elementer på de øvrige sider, der toner frem */
  var FADE = [
    '.scc-label', '.scc-grid > .scc-card', '.scc-note',
    '.scr-cat-head', '.scr-grid > .scr-card',
    '.scf-top > *', '.scf-cols > *', '.scf-legal', '.scf-bottom'
  ].join(',');
  var ZOOM = '.scc-card .scc-img, .scr-card .ph';
  var WORDS = [
    '.sc-home .sc-head-center h2', '.sc-home .sc-sol-head h2', '.sc-home .sc-prod-head h2', '.sc-home .sc-final h2',
    '.scr-cat-head h2'
  ].join(',');
  var SHINE = '.sch-btn--main, .sc-home .sc-set.is-hero .sc-btn-primary, .sc-home .sc-final .sc-btn-primary';

  function splitWords(h) {
    if (h.hasAttribute('data-scv-split')) return;
    h.setAttribute('data-scv-split', '');
    var walker = doc.createTreeWalker(h, NodeFilter.SHOW_TEXT, null), nodes = [], n, i = 0;
    while ((n = walker.nextNode())) nodes.push(n);
    nodes.forEach(function (t) {
      var parts = t.nodeValue.split(/(\s+)/), frag = doc.createDocumentFragment();
      parts.forEach(function (p) {
        if (!p) return;
        if (/^\s+$/.test(p)) { frag.appendChild(doc.createTextNode(p)); return; }
        var w = doc.createElement('span'), s = doc.createElement('span');
        w.className = 'scv-w';
        s.textContent = p;
        s.style.setProperty('--i', i++);
        w.appendChild(s);
        frag.appendChild(w);
      });
      t.parentNode.replaceChild(frag, t);
    });
    h.classList.add('scv-words');
  }

  function cleanup(el) {
    el.removeAttribute('data-scv');
    el.removeAttribute('data-scv-zoom');
    el.classList.remove('scv-in');
    el.style.removeProperty('--scv-d');
  }

  function show(el, k) {
    if (el._scvShown) return;
    el._scvShown = true;
    var d = Math.min(k, 6) * 0.08;
    el.style.setProperty('--scv-d', d + 's');
    requestAnimationFrame(function () { el.classList.add('scv-in'); });
    if (!el.classList.contains('scv-words')) setTimeout(function () { cleanup(el); }, 1800 + d * 1000);
  }

  /* Én bølge ad gangen: det, der kommer i syne samtidig, forskydes lidt */
  var pending = [];
  var io = new IntersectionObserver(function (entries) {
    var vis = [];
    entries.forEach(function (e) { if (e.isIntersecting) { vis.push(e.target); io.unobserve(e.target); } });
    vis.sort(function (a, b) {
      var ra = a.getBoundingClientRect(), rb = b.getBoundingClientRect();
      return (ra.top - rb.top) || (ra.left - rb.left);
    });
    vis.forEach(show);
  }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
  function watch(el) { pending.push(el); io.observe(el); }

  /* Sikkerhedsnet: scroller man meget hurtigt (eller hopper via et link),
     kan et element springes over. Alt, man er scrollet forbi, vises altid. */
  function sweep() {
    /* Kun det, der allerede er nået op over midten af skærmen; resten klarer observeren */
    var vh = window.innerHeight * 0.5;
    each(q('.sc-home .sc-reveal:not(.in)'), function (el) {
      if (el.getBoundingClientRect().top < vh) el.classList.add('in');
    });
    pending = pending.filter(function (el) {
      if (el._scvShown) return false;
      if (el.getBoundingClientRect().top < vh) { io.unobserve(el); show(el, 0); return false; }
      return true;
    });
  }
  var sweepT = null;
  function queueSweep() { if (!sweepT) sweepT = setTimeout(function () { sweepT = null; requestAnimationFrame(sweep); }, 150); }

  /* Forsidens kort: forskyd efter kolonne (og rækkerne i problem-kortet) */
  function stagger() {
    each(q('.sc-home .sc-pgrid, .sc-home .sc-sets, .sc-home .sc-uses, .sc-home .sc-rgrid'), function (grid) {
      var top = null, col = 0;
      each(grid.children, function (k) {
        var t = k.offsetTop;
        if (top === null || Math.abs(t - top) > 4) { top = t; col = 0; } else { col++; }
        k.style.setProperty('--scv-d', (col * 0.09) + 's');
      });
    });
    each(q('.sc-home .sc-pcards'), function (grid) {
      each(grid.children, function (k, i) { k.style.setProperty('--scv-d', (i * 0.1) + 's'); });
    });
  }

  /* Forsiden: når et element er tonet frem, får det korte overgange igen (hover/tryk) */
  var doneIO = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      doneIO.unobserve(e.target);
      var el = e.target;
      setTimeout(function () { el.classList.add('scv-done'); }, 1700);
    });
  }, { threshold: 0.12 });

  /* Lysglimt på knapperne, når de kommer i syne */
  var shineIO = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      shineIO.unobserve(e.target);
      var b = e.target;
      setTimeout(function () { b.classList.add('scv-shine-go'); }, b.classList.contains('sch-btn--main') ? 1600 : 700);
    });
  }, { threshold: 0.6 });

  /* Afslutningens baggrund bevæger sig kun, mens den er i syne */
  var liveIO = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { e.target.classList.toggle('scv-live', e.isIntersecting); });
  });

  /* FAQ på forsiden: blød åbning og lukning */
  function smoothFaq() {
    each(q('.sc-home .sc-faq details'), function (d) {
      var s = d.querySelector('summary'), a = d.querySelector('.ans');
      if (!s || !a || !a.animate) return;
      s.addEventListener('click', function (e) {
        e.preventDefault();
        if (d._scvAnim) d._scvAnim.cancel();
        var pb = getComputedStyle(a).paddingBottom;
        if (d.open) {
          var h = a.offsetHeight;
          d.classList.add('scv-closing');
          var an = a.animate([{ height: h + 'px', paddingBottom: pb, opacity: 1 }, { height: '0px', paddingBottom: '0px', opacity: 0 }], { duration: 320, easing: 'cubic-bezier(.4,0,.2,1)' });
          d._scvAnim = an;
          an.onfinish = function () { d.open = false; d.classList.remove('scv-closing'); d._scvAnim = null; };
        } else {
          d.open = true;
          var h2 = a.offsetHeight;
          var an2 = a.animate([{ height: '0px', paddingBottom: '0px', opacity: 0 }, { height: h2 + 'px', paddingBottom: pb, opacity: 1 }], { duration: 440, easing: 'cubic-bezier(.16,1,.3,1)' });
          d._scvAnim = an2;
          an2.onfinish = function () { d._scvAnim = null; };
        }
      });
    });
  }

  function init() {
    html.classList.add('scv-on');

    each(q(WORDS), function (h) {
      if (h.closest('.scp')) return;
      splitWords(h);
      watch(h);
    });
    each(q(FADE), function (el) {
      if (el.closest('.scp, .sc-home') || !belowFold(el)) return;
      el.setAttribute('data-scv', '');
      watch(el);
    });
    each(q(ZOOM), function (el) {
      if (!belowFold(el)) return;
      el.setAttribute('data-scv-zoom', '');
      watch(el);
    });

    stagger();
    var rt;
    window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(stagger, 200); }, { passive: true });
    each(q('.sc-home .sc-reveal'), function (el) { doneIO.observe(el); });

    each(q(SHINE), function (b) { b.classList.add('scv-shine'); shineIO.observe(b); });
    each(q('.sc-home .sc-final'), function (el) { liveIO.observe(el); });

    smoothFaq();

    window.addEventListener('scroll', queueSweep, { passive: true });
    window.addEventListener('hashchange', queueSweep);
    window.addEventListener('load', queueSweep);
  }

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', init);
  else init();
})();
